import React from 'react';
import { FadeIn } from './FadeIn';
import { PaymentTrust } from './PaymentTrust';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-24 md:pt-24 md:pb-32 px-6 overflow-hidden min-h-[90vh] flex items-center" data-id="element-34">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-35"></div>

      <div className="max-w-7xl mx-auto relative z-10 w-full" data-id="element-36">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-37">
          {/* TEXT COLUMN */}
          <div className="text-center lg:text-left order-1" data-id="element-38">
            <FadeIn data-id="element-39">
              <span className="text-gold font-bold tracking-[0.2em] text-xs md:text-sm uppercase mb-6 block" data-id="element-40">
                DISCOVER THE MALE PROTOCOL AND REGAIN YOUR PERFORMANCE
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-41">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-5 leading-tight" data-id="element-42">
                Do you want to recover the{' '}
                <span className="text-gold italic" data-id="element-43">real firmness</span> of your
                erections?
              </h1>
            </FadeIn>

            <FadeIn delay={0.15} data-id="element-44">
              <div className="flex items-center justify-center lg:justify-start gap-2 mb-6 flex-wrap" data-id="element-45">
                <span className="text-white font-semibold text-sm" data-id="element-46">
                  Excellent
                </span>
                <span className="text-gold text-base tracking-wide" aria-label="4.9 out of 5 stars" data-id="element-47">
                  ★★★★★
                </span>
                <span className="text-gray-300 text-sm" data-id="element-48">
                  <span className="font-bold text-white" data-id="element-49">4.9</span> out of 5
                  based on{' '}
                  <span className="font-semibold text-white" data-id="element-50">
                    18,243 reviews
                  </span>
                </span>
              </div>
            </FadeIn>

            {/* IMAGE — appears here on mobile only (right after headline) */}
            <div className="lg:hidden my-10" data-id="element-51">
              <ProductMockup data-id="element-52" />
            </div>

            <FadeIn delay={0.2} data-id="element-53">
              <h2 className="text-lg md:text-2xl text-gray-300 font-serif mb-8 leading-relaxed" data-id="element-54">
                Regain the power, confidence, and performance of your prime
                years.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-55">
              <p className="text-base md:text-lg text-gray-400 mb-10 leading-relaxed" data-id="element-56">
                Discover{' '}
                <span className="text-white font-semibold" data-id="element-57">
                  The Master Code
                </span>
                : The first comprehensive protocol designed for men who want to
                eliminate anxiety, optimize their hormones, and enjoy an
                unbreakable virility again. Discover everything you need to know
                and do to{' '}
                <span className="border-b-2 border-red-600 pb-0.5 text-gray-300 font-medium" data-id="element-58">
                  have a firm erection for longer...
                </span>
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-59">
              <div className="relative inline-block w-full md:w-auto" data-id="element-60">
                {/* Pulsing gold glow ring */}
                <div className="absolute inset-0 rounded bg-gold/40 blur-xl animate-pulse pointer-events-none" data-id="element-61"></div>
                <a href="https://templeofpages.com/cart/49096223424755:1" className="relative inline-block text-center bg-gold hover:bg-gold-light text-dark font-bold py-5 px-6 md:px-10 rounded text-base md:text-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_30px_rgba(212,175,55,0.4)] uppercase tracking-wide w-full md:w-auto" data-id="element-62">
                  YES, I WANT TO REGAIN MY POWER NOW
                </a>
              </div>
              <PaymentTrust compact data-id="element-63" />
            </FadeIn>
          </div>

          {/* IMAGE COLUMN — desktop only */}
          <div className="hidden lg:flex order-2 justify-center items-center" data-id="element-64">
            <FadeIn delay={0.2} data-id="element-65">
              <ProductMockup data-id="element-66" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}
function ProductMockup() {
  return <div className="relative w-full max-w-xl mx-auto" data-id="element-67">
      {/* Gold ambient glow behind the tablet */}
      <div className="absolute inset-0 bg-gold/25 blur-[100px] rounded-full scale-90 pointer-events-none" data-id="element-68"></div>
      <div className="absolute inset-0 bg-gold/10 blur-[60px] rounded-full scale-110 pointer-events-none" data-id="element-69"></div>

      {/* Tablet image — replace src with your final mockup URL */}
      <div className="relative" data-id="element-70">
        <img src="https://cdn.magicpatterns.com/uploads/tncTyoKx1YmmEuNQhXasRz/COMPLETO.png" alt="The Master Code – Male Health Digital Ebook displayed on a premium tablet" className="relative w-full h-auto rounded-[1.5rem] shadow-[0_50px_120px_-20px_rgba(0,0,0,0.95),0_0_70px_rgba(212,175,55,0.22)] ring-1 ring-gold/25" data-id="element-71" />

        {/* Subtle screen sheen overlay */}
        <div className="absolute inset-0 rounded-[1.5rem] bg-gradient-to-br from-white/[0.06] via-transparent to-transparent pointer-events-none" data-id="element-72"></div>
      </div>

      {/* Floor reflection / shadow puddle */}
      <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-3/4 h-12 bg-gold/15 blur-3xl rounded-full pointer-events-none" data-id="element-73"></div>
      <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-2/3 h-8 bg-black/80 blur-2xl rounded-full pointer-events-none" data-id="element-74"></div>
    </div>;
}